var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-page-outer-container ",style:({
    backgroundColor: _vm.getTemplateOption('page_background_color'),
    color: _vm.getTemplateOption('page_text_color')
  })},[_c('CContainer',{staticClass:"site-container",attrs:{"no-padding":""}},[_c('CRow',[_c('CCol',{staticClass:"site-page-inner-container",attrs:{"cols":"12"}},[(_vm.loadingSearchPage)?_c('SearchShimmer'):_vm._e(),_vm._v(" "),_c('nuxt-child')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }